import { Hidable } from "@/shared/value";
import {
  AvatarFile,
  HidableAvatarView,
} from "@/modules/common/entities/person/person-avatar";

export function PersonOption({
  name,
  avatar,
}: {
  name: string;
  avatar?: Hidable<AvatarFile>;
}) {
  return (
    <span className="flex items-center space-x-2">
      <HidableAvatarView size={"small"} data={avatar} />
      <span className="inline-block">{name}</span>
    </span>
  );
}
